import { Badge } from "./Badge";

interface BadgeType {
  id: string;
  name: string;
  description: string;
  earned_at: string;
}

interface BadgeGridProps {
  badges: BadgeType[];
  maxDisplay?: number;
}

export function BadgeGrid({ badges, maxDisplay = 8 }: BadgeGridProps) {
  // Create placeholder slots for future badges
  const totalSlots = Math.max(badges.length, maxDisplay);
  const slots = Array.from({ length: totalSlots }, (_, index) => badges[index] || null);

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Badges</h3>
      <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 gap-4">
        {slots.map((badge, index) => (
          <div key={index} className="flex justify-center">
            {badge ? (
              <Badge badge={badge} size="md" />
            ) : (
              <div className="w-12 h-12 rounded-full border-2 border-dashed border-muted-foreground/30 flex items-center justify-center">
                <div className="w-2 h-2 rounded-full bg-muted-foreground/20"></div>
              </div>
            )}
          </div>
        ))}
      </div>
      {badges.length > 0 && (
        <p className="text-sm text-muted-foreground">
          {badges.length} badge{badges.length !== 1 ? 's' : ''} earned
        </p>
      )}
    </div>
  );
}